export default __webpack_public_path__ + "static/media/information--turn-left--g1.f8929d0b.png";